import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=213f042c&scoped=true"
import script from "./file-uploader.vue?vue&type=script&setup=true&lang=js"
export * from "./file-uploader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./file-uploader.vue?vue&type=style&index=0&id=213f042c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f042c",
  null
  
)

export default component.exports